var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#E3F9FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11854_86791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 12.834H16.1667C15.25 12.834 14.5 13.584 14.5 14.5007V25.334H16.1667V14.5007H25.3333V12.834ZM24.5 16.1673H19.5C18.5833 16.1673 17.8417 16.9173 17.8417 17.834L17.8333 29.5007C17.8333 30.4173 18.575 31.1673 19.4917 31.1673H27.8333C28.75 31.1673 29.5 30.4173 29.5 29.5007V21.1673L24.5 16.1673ZM19.5 29.5007V17.834H23.6667V22.0007H27.8333V29.5007H19.5Z",
    fill: "#069AA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11854_86791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ca2ba485c2978e6c2d134b8d3fc23b18.svg";
export { ForwardRef as ReactComponent };